import axios from 'axios';
import { configureApiService } from './apiService';

const API_URL = `${process.env.REACT_APP_API_URL || '/api/v1'}/auth`;

// Helper function to decode JWT
const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const login = async (username, password) => {
    try {
        const response = await axios.post(`${API_URL}/login`, {
            userName: username,
            password: password
        });

        if (response.data.token && response.data.refreshToken) {
            const token = response.data.token;
            const decodedJwt = parseJwt(token);
            const expiration = decodedJwt ? decodedJwt.exp * 1000 : null;

            const user = {
                accessToken: token,
                refreshToken: response.data.refreshToken,
                username: response.data.username,
                fullName: response.data.fullName, // Save fullName
                roles: response.data.roles,
                expiration: expiration,
            };
            
            localStorage.setItem('user', JSON.stringify(user));
        }

        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'An error occurred during login' };
    }
};

export const logout = async () => {
    try {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            const user = JSON.parse(userStr);
            // Call backend to revoke token
            await axios.post(`${API_URL}/logout`, {
                refreshToken: user.refreshToken
            }, {
                headers: {
                    'Authorization': `Bearer ${user.accessToken}`
                }
            });
        }
    } catch (error) {
        console.error('Logout API call failed:', error);
        // Continue with local logout even if API fails
    } finally {
        localStorage.removeItem('user');
        localStorage.removeItem('selectedMenu');
        window.location.href = '/login';
    }
};

export const getCurrentUser = () => {
    try {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    } catch (error) {
        console.error("Error parsing user from localStorage", error);
        return null;
    }
};

// Configure the API service with both getCurrentUser and logout functions
configureApiService(getCurrentUser, logout);
